import React from "react";

export function SimpleTooltip({
  children, text, side = "top"
}: {
  children: React.ReactNode;
  text: string;
  side?: "top" | "bottom" | "left" | "right";
}) {
  const [open, setOpen] = React.useState(false);
  const pos = {
    top:    "bottom-full right-0 mb-2",
    bottom: "top-full right-0 mt-2",
    left:   "right-full top-1/2 -translate-y-1/2 mr-2",
    right:  "left-full top-1/2 -translate-y-1/2 ml-2",
  }[side];

  return (
    <span
      className="relative inline-flex"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onFocus={() => setOpen(true)}
      onBlur={() => setOpen(false)}
      tabIndex={0}
    >
      {children}
      {open && (
        <span
          className={`pointer-events-none absolute z-50 max-w-xs w-max break-words rounded-md bg-slate-900 px-2 py-1 text-xs leading-snug text-white shadow ${pos}`}
        >
          {text}
        </span>
      )}
    </span>
  );
}